import './custom-input.scss';
import React, { useEffect, useMemo, useState } from 'react';
import WarnIcon from '@svg/warn-circle.svg?react';
import { Input, InputProps } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import TextArea from 'antd/lib/input/TextArea';

interface CustomInputPropsI extends CustomInputProps, InputProps {
    inputType: 'INPUT';
}

interface CustomInputPropsT extends CustomInputProps, TextAreaProps {
    inputType: 'TEXTAREA';
}

interface CustomInputProps {
    errorMessage?: string;
    hideWarnMessage?: boolean;
}

export const CustomInput = React.forwardRef<any, React.PropsWithChildren<CustomInputPropsI | CustomInputPropsT>>((props, ref) => {
    const { inputType, errorMessage, hideWarnMessage, onChange, ...otherProps } = props;
    const [showMaxLengthWarn, setShowMaxLengthWarn] = useState(props.maxLength === props.value?.toString()?.length);

    useEffect(() => {
        setShowMaxLengthWarn(props.maxLength === props.value?.toString()?.length);
    }, [props.value]);

    const onChangeHandle: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e: React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange?.(e);
    };

    const showMessage = useMemo(() => !hideWarnMessage && !!(showMaxLengthWarn || errorMessage),
        [hideWarnMessage, errorMessage, showMaxLengthWarn]);

    return <div className={`custom-input ${showMaxLengthWarn && !hideWarnMessage ? 'has-warn' : ''}`} >
        {inputType === 'INPUT' ?
            <Input ref={ref} {...otherProps as InputProps} onChange={onChangeHandle} /> :
            <TextArea ref={ref} {...otherProps as TextAreaProps} onChange={onChangeHandle} />}
        {showMessage && <div className="message-wrapper">
            {errorMessage ? <div className="error-message">{errorMessage}</div> :
                <div className="warn-message"><WarnIcon />You have reached the maximum number of characters allowed</div>}
        </div>}
    </div>;
});
